import React from "react";
import Nav from "../../components/shared/Nav/Nav";
import Banner from "../../components/pages/Contact/Banner/Banner";
import Footer from "../../components/shared/Footer/Footer";
import Design from "../../components/pages/Home/Design/Design";
import WhatWeDo from "../../components/pages/Home/WhatWeDo/WhatWeDo";
import Portfolio from "../../components/pages/Home/Portfolio/Portfolio";
import Look from "../../components/pages/Home/Look/Look";
import Strategy from "../../components/pages/Home/Strategy/Strategy";
import Digital from "../../components/pages/Home/Digital/Digital";
import Grow from "../../components/pages/Home/Grow/Grow";
import Clients from "../../components/pages/Home/Clients/Clients";
import Blog from "../../components/pages/Home/Blog/Blog";
import Together from "../../components/pages/Home/Together/Together";
import TopFooter from "../../components/shared/TopFooter/TopFooter";
import Talk from "../../components/pages/Contact/Talk/Talk";
const Contact = () => {
  return (
    <div className="home-page">
      <Nav changeLogoContact />
      <Banner />
      <Talk />
      <TopFooter />
      <Footer />
    </div>
  );
};

export default Contact;
